document.addEventListener('DOMContentLoaded', function () {
  let isLoading = false;
    const loadMoreContainer = document.querySelector('.load-more-container');
  if (loadMoreContainer) {
    loadMoreContainer.style.visibility = 'hidden';
  }

  async function loadMoreProducts() {
    const button = document.querySelector('.load-more-button');

    if (!button || isLoading) return;

    isLoading = true;

    try {
      const response = await fetch(button.href);

      if (!response.ok) {
        throw new Error('Could not load next page');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const currentGrid = document.querySelector('#product-grid');
      const nextGrid = doc.querySelector('#product-grid');

      if (!currentGrid || !nextGrid) {
        throw new Error('Product grid not found');
      }

      const newProducts = nextGrid.querySelectorAll(':scope > li');

      newProducts.forEach(function (product) {
        currentGrid.appendChild(product);
      });

      const nextButton = doc.querySelector('.load-more-button');

      if (nextButton) {
        button.href = nextButton.href;
      } else {
        const container = button.closest('.load-more-container');
        if (container) container.remove();
      }

    } catch (error) {
      console.error('Infinite Scroll error:', error);
    } finally {
      isLoading = false;
    }
  }

  function checkScrollPosition() {
    const button = document.querySelector('.load-more-button');

    if (!button) return;

    const rect = button.getBoundingClientRect();

    if (rect.top < window.innerHeight + 600) {
      loadMoreProducts();
    }
  }

  window.addEventListener('scroll', checkScrollPosition, {
    passive: true
  });

  checkScrollPosition();
});